import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — restores expected web-page scroll behaviour for React Router.
 *
 * On every route change:
 *  - If the URL contains a hash (e.g. /faq#mees-section), scroll the matching
 *    element into view smoothly.
 *  - Otherwise, jump to the top of the page (window 0,0).
 *
 * Mount once, just inside <BrowserRouter>, above <Routes>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer to next tick so the target element is in the DOM after route render
      const id = hash.replace('#', '');
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Element not yet rendered — fall back to top
          window.scrollTo(0, 0);
        }
      };
      // Small delay so React has time to render the new route's content
      setTimeout(tryScroll, 50);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
